export * from './IUser.interface';
export * from './IStudent.interface';
export * from './IOpuUser.interface';
export * from './IEstablishmentUser.interface';
export * from './IQuery.interface';
export * from './establishment.interface';
export * from './establishment-search-query.interface';
export * from './paginatedData.interface';
export * from './author.interface';
export * from './category.interface';
export * from './book.interface';
export * from './contract.interface';
export * from './action-log.interface';
